import { render } from "./TicketDetailsPage.vue?vue&type=template&id=4b6249d9&ts=true"
import script from "./TicketDetailsPage.vue?vue&type=script&lang=ts"
export * from "./TicketDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__